import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHomeAlt } from '@fortawesome/pro-regular-svg-icons';
import { faUserTie, faHotel } from '@fortawesome/free-solid-svg-icons';
//Component
import NoDataToDisplay from '../../../../../components/NoDataToDisplay';
import MatchingConfigParams from '../../../matchingConfig/CreateEditMatchingConfiguration/matchingConfigParameters';
import Wait4Me from '../../../../../components/Wait4Me';
import { ALERT_SOURCE_MAPPING } from '../../../../../util/GlobalConstant';

import { Tooltip } from 'antd';

export const MatchingConfigs = ({
  matchingConfigs,
  tunningParameter,
  activeKey,
  setActiveKey,
  getMatchingConfigParameters,
  currentModule,
  riskIndicators,
  getMatchingConfigRiskIndicators
}) => {
  const [matchingType, setMatchingType] = useState(0);
  const [riskIndicatorsData, setRiskIndicatorsData] = useState();
  useEffect(() => {
    if (currentModule === parseInt(ALERT_SOURCE_MAPPING.RS)) {
      getMatchingConfigRiskIndicators({
        id: matchingConfigs[matchingType].matchingConfigId
      });
    } else {
      getMatchingConfigParameters({
        id: matchingConfigs?.[matchingType]?.matchingConfigId
      });
    }
  }, [matchingType, currentModule]);

  useEffect(() => {
    setRiskIndicatorDataInDeploy(riskIndicators);
  }, [riskIndicators]);

  const setRiskIndicatorDataInDeploy = (riskIndicators) => {
    const transformedData = riskIndicators.data.map((item) => {
      return {
        displayName: item.parameter.displayName,
        name: item.parameter.name,
        weight: item.weight
      };
    });
    setRiskIndicatorsData(transformedData);
  };

  const getMapableParameters = (parameters) => {
    return parameters?.map((tab) => ({
      ...tab,
      parameterList: tab?.parameterList?.map((parameter, i) => ({
        ...parameter,
        key: i,
        score: {
          unique_id: i,
          value: parameter.actualScore?.toFixed(2),
          recomended: {
            [parameter.recommendedScore?.toFixed(
              2
            )]: `${parameter.recommendedScore?.toFixed(2)}`
          },
          description: parameter.description,
          behaviour: parameter.trend
        }
      }))
    }));
  };

  const getWeightage = (parameters) => {
    return parameters?.reduce(
      (acc, param) => ({
        ...acc,
        [param.categoryType]: parseFloat((param?.weight * 100).toFixed(2)) || 0
      }),
      {}
    );
  };

  const getHardRule = (parameters) => {
    if (parameters != undefined) {
      const result = parameters?.reduce((acc, param) => {
        if (param.hardRule !== undefined) {
          return {
            ...acc,
            [param.categoryType]: param.hardRule
          };
        }
        return acc;
      }, {});
      return result;
    } else return {};
  };

  const getIcon = (item) => {
    if (item?.customerTypeId == 'CT00001') return faUserTie;
    else if (item?.customerTypeId == 'CT00002') return faHotel;
    else return faHomeAlt;
  };

  const handleCustomerTypeCardChange = (item) => {
    setMatchingType(item);
  };

  if (tunningParameter?.isLoading)
    return (
      <LoadingWrapper>
        <Wait4Me />
      </LoadingWrapper>
    );
  else if (matchingConfigs?.length !== 0)
    return (
      <React.Fragment>
        <CardWrapper>
          {matchingConfigs?.map((item, index) => {
            return (
              <Card
                key={index}
                id={`customerType_card${index}`}
                onClick={() => handleCustomerTypeCardChange(index)}
                style={{
                  background: matchingType == index ? '#EDF7FF' : '#FFF'
                }}>
                <IconWrapper>
                  <FontAwesomeIcon
                    icon={getIcon(item)}
                    color={'#335777'}
                    style={{ fontSize: '16px' }}
                  />
                </IconWrapper>
                <div>
                  <CardTitle>
                    <Tooltip
                      title={
                        item?.customerTypeDisplayName
                          ? item?.customerTypeDisplayName
                          : 'Default'
                      }>
                      {item?.customerTypeDisplayName
                        ? String(item?.customerTypeDisplayName).length > 15
                          ? String(item?.customerTypeDisplayName).substring(
                              0,
                              10
                            )
                          : item?.customerTypeDisplayName
                        : 'Default'}
                    </Tooltip>
                  </CardTitle>
                  <CardContent>{item?.matchingConfigName}</CardContent>
                </div>
              </Card>
            );
          })}
        </CardWrapper>
        <MatchingConfigParams
          data={getMapableParameters(tunningParameter?.data)}
          weightage={getWeightage(tunningParameter?.data)}
          hardRule={getHardRule(tunningParameter?.data)}
          activeKey={activeKey}
          deployedRiskIndicators={riskIndicatorsData}
          setActiveKey={setActiveKey}
          disabled={true}
          isDeployProduction={currentModule === 17}
          currentModule={currentModule}
        />
      </React.Fragment>
    );
  else return <NoDataToDisplay />;
};

const LoadingWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 250px;
`;

const CardWrapper = styled.div`
  display: flex;
  align-items: center;
  overflow-x: scroll;
`;

const Card = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px solid #335777;
  box-sizing: border-box;
  border-radius: 4px;
  width: 400px;
  height: 64px;
  cursor: pointer;
  margin-right: 58px;
`;

const IconWrapper = styled.div`
  background: transparent;
  border: 2px solid #335777;
  box-sizing: border-box;
  border-radius: 50%;
  margin-right: 8px;
  display: grid;
  place-items: center;
  flex-basis: 34px;
  width: 100px;
  height: 34px;
`;

const CardTitle = styled.h5`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #335777;
`;

const CardContent = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 12px;
  color: #335777;
`;

export default MatchingConfigs;
